import { render } from "./ExternalShopsTestView.vue?vue&type=template&id=7970c522&scoped=true"
import script from "./ExternalShopsTestView.vue?vue&type=script&lang=js"
export * from "./ExternalShopsTestView.vue?vue&type=script&lang=js"

import "./ExternalShopsTestView.vue?vue&type=style&index=0&id=7970c522&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7970c522"]])

export default __exports__